import ApiService from "../api";

export default class DespesaService extends ApiService {

    constructor() {
        super("/api/despesas");
    }

    atualizaDespesas(dataInicio, dataFim) {
        return this.put(`?dataInicio=${dataInicio}&dataFim=${dataFim}`);
    }

    log() {
        return this.get("/log");
    }

    listaDespesasPorData(ano, mes, filial, centro, conta) {
        var params = "?";
        if (ano) {
            params += `ano=${ano}`;
        }
          if ( mes) {
            params += `&mes=${mes}`;
        }
        return this.get(`/${filial}/${centro}/${conta}/data${params}`);
    }

    listaPorNota(nota) {
        return this.get(`/nota-completa/${nota}`);
    }

    listaPorHistorico(data) {
        return this.post(`/historico`, data);
    }

    listaDespesas(ano, filial, centro, conta) {
        return this.get(`/procurar-despesas/${ano}/${filial}/${centro}/${conta}`);
    }

    listarDespesasPaginada(values = {}, pageable = {}, filtro = "") {
        const {
            ano = [],
            logistico = [],
            centroCusto = [],
            contaContabil = [],
            filial = [],
            tipo = [],
            responsavel = []
        } = values;

        const {
            page = 0,
            size = 10,
        } = pageable;

        const params = new URLSearchParams();

        if (ano) params.append("ano", ano.join(","));
        if (centroCusto.length) params.append("centroCusto", centroCusto.join(","));
        if (contaContabil.length) params.append("contaContabil", contaContabil.join(","));
        if (logistico.length) params.append("logistico", logistico.join(","));
        if (filial.length) params.append("filial", filial.join(","));
        if (tipo.length) params.append("tipo", tipo.join(","));
        if (responsavel.length) params.append("responsavel", responsavel.join(","));
        if (filtro) params.append("search", filtro);

        params.append("page", page);
        params.append("size", size);
        params.append("sort", `data,desc`);


        return this.get(`?${params}`);
    }

    importarExcel({
        file,
        filial,
        data,
        conta,
        historico,
        valor,
        centroCusto,
        doc
    }) {
        const formData = new FormData();

        formData.append("file", file);
        formData.append("filial", filial);
        formData.append("data", data);
        formData.append("conta", conta);
        formData.append("historico", historico);
        formData.append("valor", valor);
        formData.append("centroCusto", centroCusto);
        formData.append("doc", doc);

        return this.post("/importar", formData, {
            headers: {
                "Content-Type": "multipart/form-data"
            }
        });
    }

    deletar(dataInicial, dataFinal) {
        return this.delete(`/da?dataInicio=${dataInicial}&dataFinal=${dataFinal}`);
    }

}
